import { render, staticRenderFns } from "./tjpie.vue?vue&type=template&id=66ba12a9&"
import script from "./tjpie.vue?vue&type=script&lang=js&"
export * from "./tjpie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports